<template>
    <div class="admin-layout">
        <app-header></app-header>
        <app-sidebar></app-sidebar>

        <div class="main">
            <div class="py-1 text-center editing mt-5 bg-danger" v-if="!$route.meta.noTitle">
                <small class="m-0 text-white">
                    Now Editing | {{$route.meta.title}}
                </small>
            </div>
            <div class="py-1 mt-5" v-else>
            </div>
            <slot/>
        </div>

        <app-footer></app-footer>
    </div>
</template>
<script>
  import AppHeader from '../components/admin/AppHeader.vue'
  import AppFooter from '../components/admin/AppFooter.vue'
  import AppSidebar from '../components/admin/AppSidebar.vue'

  export default {
    data () {
      return {}
    },
    components: {
      AppHeader,
      AppFooter,
      AppSidebar
    }
  }
</script>

<style lang="scss">
    .main {
        margin-left: 52px;
        margin-bottom: 70px;
    }
</style>